import { RECEIVE_PAGES } from './../actions/PagesAction';

const defaultState = {
    fetched: false,
    data   : null
};

const PagesReducer = (state = defaultState, action) =>
{
    let newState;

    switch(action.type)
    {
        case RECEIVE_PAGES:
            newState = {
                ...state,
                fetched: true,
                data: action.data
                };
            break;
        
        default:
            newState = state;
    }

    return newState;
};

export default PagesReducer;




// WEBPACK FOOTER //
// ./src/reducers/PagesReducer.js